// Filter function to get unique values from an array
export function onlyUnique(value: any, index: any, array: any[]): boolean {
    return array.indexOf(value) === index;
}

export function formatDaysDuration(days: number): string {
    if (days >= 60) {
        const months = Math.round(days / 30);
        return `${months} ${months === 1 ? "måned" : "måneder"}`;
    }
    if (days >= 14) {
        const weeks = Math.round(days / 7);
        return `${weeks} ${weeks === 1 ? "uke" : "uker"}`;
    }
    return `${days} ${days === 1 ? "dag" : "dager"}`;
}
